import firebase from 'firebase/app';
import db from '../firebaseInit';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const getPreviousPersonalBest = (boardId, callbackFunc) => {
  const user = firebase.auth().currentUser;
  db.collection('users')
    .doc(user.uid)
    .collection('personalBests')
    .doc(boardId)
    .get()
    .then(document => {
      if (document.data()) {
        callbackFunc(document.data().totalDurationMs);
      } else {
        callbackFunc(null);
      }
    })
    .catch(err => {
      this.$snotify.error('Error getting previous PB', '', NOTIFICATION_SETTINGS);
    });
};

export default getPreviousPersonalBest;
